export default "__VITE_ASSET__AnoYE4vk_ie4l2$26eIjSw__"